import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/pub/close-square.png'


const _withScopeId = n => (_pushScopeId("data-v-e130f0c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-header" }
const _hoisted_2 = { class: "title real-title" }
const _hoisted_3 = { class: "m-mulit-dialog" }
const _hoisted_4 = { class: "title fake-title" }
const _hoisted_5 = { class: "m-dialog-inner" }
const _hoisted_6 = { class: "multi-base-info" }
const _hoisted_7 = { class: "desc-con" }
const _hoisted_8 = { class: "paper-count" }
const _hoisted_9 = {
  key: 0,
  class: "multi-list",
  id: "multiList"
}

import PaperItem from './PaperItem.vue';
    import { computed } from 'vue';
    import { PaperViewFrom } from '@/const/paper'; 
    import { useRouter } from "vue-router";
    
export default /*#__PURE__*/_defineComponent({
  __name: 'MultiPaperDetail',
  props: {
        show: {
            type: Boolean,
            default: false,
        },
        packPaperList: {
            type: Array,
            default: () => ([]),
        },
        packPaperInfo: {
            type: Object,
            default: () => ({
                title: '',
                paper_num: 0,
                detail: ''
            }),
        },
        from: {
            type: Number,
            default: PaperViewFrom.SEARCHLIST,
        },
        packPaperTime: {
            type: String,
            default: '',
        },
    },
  emits: ['onClose'],
  setup(__props, { emit: emits }) {

const props = __props;

    const router = useRouter();
    
    
    const visible = computed(() => props.show)
    const packPaperTime = computed(() => props.packPaperTime)
    const handleItemClick = (item) => {
        // 单卷
        const url = router.resolve({
            path: '/single-paper',
            query: {
                'paper_id': item.paper_id,
            }
        });
        window.open(url.href, '_blank');
    }
    const handleClose = () => {
        emits('onClose')
    }

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    center: "",
    "align-center": "",
    "show-close": false,
    "close-on-click-modal": false,
    class: "multi-paper-dia"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "close",
          src: _imports_0,
          onClick: handleClose
        }),
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.packPaperInfo.title), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.packPaperInfo.title), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createTextVNode(_toDisplayString(__props.packPaperInfo.detail) + " ", 1),
              _createElementVNode("div", _hoisted_8, " 共" + _toDisplayString(__props.packPaperInfo.paper_num) + "份试卷 ", 1)
            ])
          ]),
          (__props.packPaperList?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.packPaperList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "group-wrap",
                    key: `group-row-${index}`
                  }, [
                    (item?.group_title)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: `group-${item?.group_id}`,
                          class: "u-group-title"
                        }, _toDisplayString(item?.group_title || ''), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.paper_list, (tile, i) => {
                      return (_openBlock(), _createBlock(PaperItem, {
                        onOnItemClick: () => handleItemClick(tile),
                        class: _normalizeClass(!i ? 'no-border' : ''),
                        key: `group-${index}-${tile?.paper_id}-${i}`,
                        data: tile,
                        from: __props.from,
                        time: packPaperTime.value
                      }, null, 8, ["onOnItemClick", "class", "data", "from", "time"]))
                    }), 128))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})